/*

Supported languages

English - en
Spanish - es
French - fr
Russian - ru
Japanese - ja	
Indonesian - id

*/

export function bookingStatusLocale(status, lang) {
    let statusLabelSpec = {}, requestLang = lang || 'en-US';

    if (status === 'pending') {
        statusLabelSpec = {
            'en-US': 'New Order',
            'es': 'PENDIENTE',
            'fr-FR': 'EN ATTENTE',
            'ru-RU': 'ОЖИДАНИЕ',
            'ja-JP': '保留中',
            'id-ID': 'Orderan Baru',
            'ar': 'قيد الانتظار'
        };
    }

    if (status === 'cancelledByUser') {
        statusLabelSpec = {
            'en-US': 'Cancelled',
            'es': 'CANCELADO',
            'fr-FR': 'ANNULÉ',
            'ru-RU': 'ОТМЕНЕН',
            'ja-JP': 'キャンセル',
            'id-ID': 'Dibatalkan Customer',
            'ar': 'Cancelled'
        };
    }

    if (status === 'approved') {
        statusLabelSpec = {
            'en-US': 'Confirmed',
            'es': 'CONFIRMADO',
            'fr-FR': 'CONFIRMÉ',
            'ru-RU': 'ПОДТВЕРЖДЕНО',
            'ja-JP': '確認済み',
            'id-ID': 'Diproses Toko',
            'ar': 'مؤكد'
        };
    }

    if (status === 'declined') {
        statusLabelSpec = {
            'en-US': 'Declined',
            'es': 'DECLINADO',
            'fr-FR': 'DIMINUÉ',
            'ru-RU': 'ОТКЛОНЕН',
            'ja-JP': '辞退',
            'id-ID': 'Ditolak',
            'ar': 'رفض'
        };
    }

    if (status === 'expired') {
        statusLabelSpec = {
            'en-US': 'Expired',
            'es': 'DECLINADO',
            'fr-FR': 'DIMINUÉ',
            'ru-RU': 'ОТКЛОНЕН',
            'ja-JP': '辞退',
            'id-ID': 'Batal Otomatis',
            'ar': 'رفض'
        };
    }

    if (status === 'cancelledByPartner') {
        statusLabelSpec = {
            'en-US': 'Cancelled by store',
            'es': 'CANCELADO POR TIENDA',
            'fr-FR': 'ANNULÉ PAR MAGASIN',
            'ru-RU': 'ОТМЕНЕНО МАГАЗИНОМ',
            'ja-JP': 'ストアによってキャンセルされました',
            'id-ID': 'Dibatalkan Toko',
            'ar': 'تم الإلغاء من قبل المتجر'
        };
    }

    if (status === 'readyForDelivery') {
        statusLabelSpec = {
            'en-US': 'Looking for driver',
            'es': 'LISTO PARA RECOGER',
            'fr-FR': 'PRÊT POUR LE RAMASSAGE',
            'ru-RU': 'ГОТОВ',
            'ja-JP': 'ピックアップの準備ができて',
            'id-ID': 'Mencari Driver',
            'ar': 'جاهز للإستلام'
        };
    }

    if (status === 'driverFound') {
        statusLabelSpec = {
            'en-US': 'Driver Found!',
            'es': 'CONDUCTOR ENCONTRADO',
            'fr-FR': 'CONDUCTEUR TROUVÉ',
            'ru-RU': 'ВОДИТЕЛЬ НАЙДЕН',
            'ja-JP': 'ドライバーが見つかりました',
            'id-ID': 'Driver Ditemukan!',
            'ar': 'تم العثور على السائق'
        };
    }

    if (status === 'readyForPickup') {
        statusLabelSpec = {
            'en-US': 'ready for pickup',
            'es': 'LISTO PARA RECOGER',
            'fr-FR': 'PRÊT POUR LE RAMASSAGE',
            'ru-RU': 'ГОТОВ',
            'ja-JP': 'ピックアップの準備ができて',
            'id-ID': 'Siap Diambil',
            'ar': 'جاهز للإستلام'
        };
    }

    if (status === 'deliveryNotFound') {
        statusLabelSpec = {
            'en-US': 'Delivery failed',
            'es': 'ENTREGA FALLIDA',
            'fr-FR': 'LIVRAISON ÉCHOUÉE',
            'ru-RU': 'ДОСТАВКА НЕ УДАЛАСЬ',
            'ja-JP': '配信に失敗しました',
            'id-ID': 'Pengantaran Gagal',
            'ar': 'فشل التسليم'
        };
    }

    if (status === 'deliveryApproved') {
        statusLabelSpec = {
            'en-US': 'Delivery confirmed',
            'es': 'ENTREGA CONFIRMADA',
            'fr-FR': 'LIVRAISON CONFIRMÉ',
            'ru-RU': 'ДОСТАВКА ПОДТВЕРЖДЕНА',
            'ja-JP': '配達が確認されました',
            'id-ID': 'Pengantaran Dikonfirmasi',
            'ar': 'تم تأكيد التسليم'
        };
    }

    if (status === 'deliveryDeclined') {
        statusLabelSpec = {
            'en-US': 'Delivery declined',
            'es': 'ENTREGA RECHAZADA',
            'fr-FR': 'LIVRAISON REFUSÉE',
            'ru-RU': 'ДОСТАВКА ОТКЛОНЕНА',
            'ja-JP': '配達が拒否されました',
            'id-ID': 'Pengantaran Ditolak',
            'ar': 'التسليم رفض'
        };
    }

    if (status === 'cancelledByDelivery') {
        statusLabelSpec = {
            'en-US': 'Delivery cancelled',
            'es': 'ENTREGA CANCELADA',
            'fr-FR': 'LIVRAISON ANNULÉ',
            'ru-RU': 'ДОСТАВКА ОТМЕНЕНА',
            'ja-JP': '配達がキャンセルされました',
            'id-ID': 'Dibatalkan Driver',
            'ar': 'تم إلغاء التسليم'
        };
    }

    if (status === 'deliveryConfirmed') {
        statusLabelSpec = {
            'en-US': 'Delivery picked up',
            'es': 'ENTREGA RECOGIDO',
            'fr-FR': 'LIVRAISON RAMASSÉS',
            'ru-RU': 'ДОСТАВКА ЗАБРАНА',
            'ja-JP': '配達物を受け取りました',
            'id-ID': 'Pengantaran Diambil',
            'ar': 'التقطت التسليم'
        };
    }

    if (status === 'startDelivery') {
        statusLabelSpec = {
            'en-US': 'Delivery in progress',
            'es': 'ENTREGA EN CURSO',
            'fr-FR': 'LIVRAISON EN COURS',
            'ru-RU': 'ДОСТАВКА В ПРОЦЕССЕ',
            'ja-JP': '進行中の配信',
            'id-ID': 'Sedang Diantar',
            'ar': 'التسليم قيد التقدم'
        };
    }

    if (status === 'completed') {
        statusLabelSpec = {
            'en-US': 'Delivered',
            'es': 'ENTREGADO',
            'fr-FR': 'LIVRÉ',
            'ru-RU': 'ДОСТАВЛЕН',
            'ja-JP': '配信',
            'id-ID': 'Selesai Diantar',
            'ar': 'تم التوصيل'
        };
    }

    if (status === 'failed') {
        statusLabelSpec = {
            'en-US': 'Unable to delivered',
            'es': 'INCAPAZ DE ENTREGA',
            'fr-FR': 'IMPOSSIBLE DE LIVRER',
            'ru-RU': 'НЕВОЗМОЖНО ДОСТАВИТЬ',
            'ja-JP': '配信できません',
            'id-ID': 'Gagal',
            'ar': 'غير قادر على التسليم'
        };
    }

    // RideBooking.tripStatus. 'approved', 'declined', 'expired' and 'completed'
    // are shared with the delivery statuses above.
    if (status === 'created') {
        statusLabelSpec = {
            'en-US': 'New Trip',
            'id-ID': 'Trip Baru'
        };
    }

    if (status === 'scheduled') {
        statusLabelSpec = {
            'en-US': 'Scheduled',
            'id-ID': 'Terjadwal'
        };
    }

    if (status === 'locationReached') {
        statusLabelSpec = {
            'en-US': 'Driver arrived',
            'id-ID': 'Driver Tiba'
        };
    }

    if (status === 'started') {
        statusLabelSpec = {
            'en-US': 'Trip in progress',
            'id-ID': 'Sedang Berjalan'
        };
    }

    if (status === 'declineByRider') {
        statusLabelSpec = {
            'en-US': 'Declined by customer',
            'id-ID': 'Ditolak Customer'
        };
    }

    if (status === 'cancelledByRider') {
        statusLabelSpec = {
            'en-US': 'Cancelled by customer',
            'id-ID': 'Dibatalkan Customer'
        };
    }

    if (status === 'cancelledByDriver') {
        statusLabelSpec = {
            'en-US': 'Cancelled by driver',
            'id-ID': 'Dibatalkan Driver'
        };
    }

    if (status === 'pickUpRequest') {
        statusLabelSpec = {
            'en-US': 'Delivery done',
            'es': 'entrega hecho',
            'fr-FR': 'Livraison effectuée',
            'ru-RU': 'Доставка выполненаk',
            'ja-JP': '配達完了',
            'id-ID': 'Selesai',
            'ar': 'تم التسليم'
        };
    }

    return status ? (statusLabelSpec[requestLang] ? statusLabelSpec[requestLang] : statusLabelSpec['en-US']) : '';
}
